import * as z from "zod/v4";

export const merchantHasPricingTests = {
  name: "merchantHasPricingTests" as const,
  input: z.object({}),
  output: z.object({ hasPricingTests: z.boolean() }),
};
